var _defs, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultOffBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n        fill: none; /* Changed from white to none */\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.97,
    cy: 37.5,
    r: 12.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.14,47.95c-1.47-3.18-2.28-6.72-2.28-10.45s.82-7.27,2.28-10.45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.81,27.05c1.47,3.18,2.28,6.72,2.28,10.45s-.82,7.27-2.28,10.45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultOffBlack);
export default __webpack_public_path__ + "static/media/default - Off Black.433522db9bed0440d41c603e1a94094b.svg";
export { ForwardRef as ReactComponent };